<template>
  <div class="business-warp" v-loading="loading">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="文章标题">
        <el-input v-model="form.title" style="width: 600px;"></el-input>
      </el-form-item>
      <el-form-item label="文章排序">
        <el-input v-model="form.sort" style="width: 600px;"></el-input>
      </el-form-item>
      <el-form-item label="文章内容">
        <Uediter
          :text="form.text"
          :config="ueditor.config"
          @contentChange="contentChangeFunc"
          ref="ue1"
        ></Uediter>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Uediter from "@/components/UE.vue";
import BusinessApi from "@/api/business.js";

export default {
  components: {
    /*编辑器*/
    Uediter
  },
  data() {
    return {
      loading: false,
      form: {
        title: "",
        text: "",
        sort: "",
        id: ""
      },
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 600,
          initialFrameHeight: 500
        }
      }
    };
  },
  created() {
    const storedRowData = localStorage.getItem("editActivityRow");
    if (storedRowData) {
      this.form = JSON.parse(storedRowData);
    }
  },
  methods: {
    /*获取常用说明富文本内容1*/
    contentChangeFunc(e) {
      this.form.text = e;
    },
    onSubmit() {
      console.log("submit!", this.form);
      let self = this;
      let Params = self.form;
      if (Params.title == "" || Params.text == "" || Params.sort == "") {
        self.$message.error("请将信息填写完整");
        return;
      }
      self.loading = true;
      BusinessApi.editnotice(Params, true)
        .then(res => {
          // let list = [];
          console.log(res);
          if (res.code == 1) {
            self.$message({
              message: "提交成功",
              type: "success"
            });
          }
          self.loading = false;
          self.$router.back(-1);
        })
        .catch(error => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.business-warp {
  margin: 0 10vw;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/notice/editactivity/index.vue